import React, { useEffect, useState } from "react";
import { FaFilter,FaArrowUp } from "react-icons/fa";
import axios from "axios";
import CandidateCard from "../Dice/candidatecard.js";
import {  employmentTypeOptions, ProfilesSearch, workPermitOptions } from "../../apiconstants/constants.js";
import CandidateDetailModal from "./candidateprofile.js";
import { build } from "pdfjs-dist";
import { IntelliSearch } from "../../apiconstants/constants.js";
import Swal from "sweetalert2";
import { useCountry } from "../../contexts/countrycodecontext.js";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Select from "react-select"
import { ContactRoundIcon } from "lucide-react";
const DiceCandidatesList = ({ 
  keyword: initialKeyword,
  location: initialLocation,
  willingToRelocate: initialRelocate,
  searchTriggered,
  isIntelliSearch = false,
  intelliResults = [],
  intelliInput = "",
  intelliJobTitles = [],
  intelliLocations = [],
 
}) => {
  const [keyword, setKeyword] = useState(initialKeyword || "");
  const [location, setLocation] = useState(initialLocation || "");
  const [willingToRelocate, setWillingToRelocate] = useState(initialRelocate || "");
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const navigate = useNavigate();
  const [showScroll, setShowScroll] = useState(false);

const timezoneOptions = [
  { value: "Eastern Time", label: "Eastern Time" },
  { value: "Central Time", label: "Central Time" },
  { value: "Mountain Time", label: "Mountain Time" },
  { value: "Pacific Time", label: "Pacific Time" },
  { value: "Alaska Time", label: "Alaska Time" },
  { value: "Hawaii Time", label: "Hawaii Time" },
  { value: "Atlantic Time", label: "Atlantic Time" },
  { value: "Newfoundland Time", label: "Newfoundland Time" },
  { value: "India Standard Time", label: "India Standard Time" },
  { value: "Nepal Time", label: "Nepal Time" },
  { value: "China Standard Time", label: "China Standard Time" },
  { value: "Japan Standard Time", label: "Japan Standard Time" },
  { value: "Korea Standard Time", label: "Korea Standard Time" },
  { value: "Australian Western Time", label: "Australian Western Time" },
  { value: "Australian Central Time", label: "Australian Central Time" },
  { value: "Australian Eastern Time", label: "Australian Eastern Time" },
  { value: "Central European Time", label: "Central European Time" },
  { value: "Eastern European Time", label: "Eastern European Time" },
  { value: "Western European Time", label: "Western European Time" },
];

useEffect(() => {
  const handleScroll = () => {
    if (window.scrollY > 300) setShowScroll(true);
    else setShowScroll(false);
  };
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

  const [searchParams, setSearchParams] = useState({
    jobTitleFilter: "",
    skillsFilter: "",
    experienceFilter: "",
    willingToSwitch: "",
    employmentType: "",
    workPermit: "",
    sortBy: "relevancy",
     lastActive: "90",
     hasEmail: true,        // ✅ default checked
  hasPhoneNumber: true,
    companyNameFilter: "", // ✅ fix key name
  });
const token = localStorage.getItem('jwtToken');
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;
  const [showModal, setShowModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
 const [selectedCandidates, setSelectedCandidates] = useState([]);
  const { selectedCountry} = useCountry();
  const [restoredState, setRestoredState] = useState(false);
const [totalPages, setTotalPages] = useState(0);

const handleViewDetails = async (candidate) => {
  const result = await Swal.fire({
    title: "View Candidate Details?",
    text: "Viewing this candidate counts as one view. Are you sure you want to proceed?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, View Details",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    // ✅ Track view count (optional)
    localStorage.setItem("lastViewedCandidateId", candidate.candidateId || candidate.id);

    // ✅ Open modal (in same page)
    setSelectedCandidate(candidate.candidateId || candidate.id)
    setShowModal(true);
  }
};

const handleNavigateToDetails = async (candidate) => {
  const result = await Swal.fire({
    title: "View Candidate Details?",
    text: "Viewing this candidate counts as one view. Are you sure you want to proceed?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Go to Details Page",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    // Save state before leaving
    localStorage.setItem("diceListState", JSON.stringify({
      currentPage,
      scrollY: window.scrollY,
      filters: searchParams,
      selectedFilters,
    }));

    navigate(`/Employer/candidate-details/${candidate.candidateId || candidate.id}`);
  }
};
useEffect(() => {
  const savedState = localStorage.getItem("diceListState");
  if (savedState) {
    const parsed = JSON.parse(savedState);
    setCurrentPage(parsed.currentPage || 1);
    setSearchParams(parsed.filters || {});
    setSelectedFilters(parsed.selectedFilters || []);
    setKeyword(parsed.keyword || "");
    setLocation(parsed.location || "");
    setWillingToRelocate(parsed.willingToRelocate || "");
    
    setTimeout(() => {
      window.scrollTo(0, parsed.scrollY || 0);
    }, 300);

    setRestoredState(true); // mark restored
    localStorage.removeItem("diceListState");
  } else {
    if (searchTriggered) handleSearch();
  }
}, []);

useEffect(() => {
  if (restoredState) {
    handleSearch(); // fetch candidates for restored state
    setRestoredState(false);
  }
}, [restoredState]);


// ✅ Unified search function
const handleSearch = (page = 1) => {
  const activeFilters = {};

  if (selectedFilters.includes("jobTitle") && searchParams.jobTitleFilter)
    activeFilters.JobTitle = searchParams.jobTitleFilter;
  if (selectedFilters.includes("skills") && searchParams.skillsFilter)
    activeFilters.Skills = searchParams.skillsFilter;
  if (selectedFilters.includes("experience") && searchParams.experienceFilter)
    activeFilters.YearsExperience = searchParams.experienceFilter;
  if (selectedFilters.includes("willingToSwitch") && searchParams.willingToSwitch)
    activeFilters.LikelyToSwitch = searchParams.willingToSwitch === "Yes";
  if (selectedFilters.includes("employmentType") && searchParams.employmentType)
    activeFilters.EmploymentType = searchParams.employmentType;
  if (selectedFilters.includes("workPermit") && searchParams.workPermit)
    activeFilters.WorkPermit = searchParams.workPermit;
if (selectedFilters.includes("lastActive") && searchParams.lastActive)
  activeFilters.LastActive = parseInt(searchParams.lastActive);
if (selectedFilters.includes("timezones") && searchParams.timezones?.length) {
  activeFilters.TimeZones = JSON.stringify(searchParams.timezones);
}

  fetchCandidates(
    keyword,
    location,
    willingToRelocate,
    activeFilters,
    page,
    isIntelliSearch
      ? {
      
          intelliInput,
          intelliJobTitles,
          intelliLocations,
        }
      : null
  );
};

// ✅ Unified fetch candidates function
const fetchCandidates = async (
  keyword,
  location,
  relocate,
  filters = {},
  page = 1,
  intelliProps = null
) => {
  setLoading(true);
  let relocateValue =
    relocate?.toLowerCase() === "yes"
      ? true
      : relocate?.toLowerCase() === "no"
      ? false
      : "";

  try {
    if (intelliProps) {
      // 🧠 IntelliSearch API
      const validJobTitles = intelliProps.intelliJobTitles.filter((t) => t.trim() !== "");
      const jobTitleKeyword = validJobTitles.map((t) => `"${t.trim()}"`).join(" OR ");
      const validLocations = intelliProps.intelliLocations.filter((l) => l.trim() !== "");

      const payload = {
        input: intelliProps.intelliInput || "",
        keyword: keyword || "",
        jobTitleKeyword,
        jobTitle: filters.JobTitle || keyword || "",
        locations: validLocations,
        skills: filters.Skills || "",
        sortBy: searchParams.sortBy || "relevancy",
        yearsExperience: filters.YearsExperience || "",
        employmentType: filters.EmploymentType || "",
        workPermit: filters.WorkPermit || "",
        likelyToSwitch: filters.LikelyToSwitch === true,
        willingToRelocate: relocateValue === true,
        willingToRelocateIncludeLocals: true,
        willingToRelocatePreferredLocationsOnly: true,
        page,
        pageSize: recordsPerPage,
       lastActive: filters.LastActive || 90,
         hasEmail: searchParams.hasEmail ?? true,
      hasPhoneNumber: searchParams.hasPhoneNumber ?? true,
     company: searchParams.companyNameFilter || "",
  



      };

      console.log("🧠 IntelliSearch payload (filters/sort):", payload);

   const res = await axios.post(
  IntelliSearch.APIURL,
  {
    ...payload,
  
  },
  {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }
);



      setCandidates(res.data?.data || []);
      const totalPagesCalculated = Math.ceil(
        (res.data?.count || res.data?.meta?.totalCount || 0) / recordsPerPage
      );
      setTotalPages(totalPagesCalculated > 50 ? 50 : totalPagesCalculated);
    } else {
     
    // 🌐 Profile Search API
let url = `${ProfilesSearch.APIURL}?`;

if (keyword) url += `Keyword=${encodeURIComponent(keyword)}&`;
if (location) url += `Location=${encodeURIComponent(location)}&`;
if (searchParams.sortBy) url += `SortBy=${encodeURIComponent(searchParams.sortBy)}&`;

// ✅ Add LastActive only once (and NOT in filters)
if (!filters.LastActive && !filters.LastActiveDays) {
  url += `LastActive=90&`;
}

if (relocateValue !== "") {
  url += `WillingToRelocate=${relocateValue}&`;
  if (relocateValue === true) {
    url += `WillingToRelocateIncludeLocals=true&WillingToRelocatePreferredLocationsOnly=true&`;
  }
}

 // ✅ Append Company Name if provided

if (searchParams.companyNameFilter && searchParams.companyNameFilter.trim() !== "") {
  url += `Company=${encodeURIComponent(searchParams.companyNameFilter)}&`;
}


  url += `HasEmail=${searchParams.hasEmail ?? true}&`;
    url += `HasPhoneNumber=${searchParams.hasPhoneNumber ?? true}&`;
    // Append timezone filter
if (filters.TimeZones) {
  url += `TimeZones=${encodeURIComponent(filters.TimeZones)}&`;
}
Object.entries(filters).forEach(([key, value]) => {
  if (key === "TimeZones") return; // ❌ skip duplicate
  if (value !== undefined && value !== "") {
    url += `${key}=${encodeURIComponent(value)}&`;
  }
});

url = url.replace(/&$/, "");
url += `&page=${page}&pageSize=${recordsPerPage}`;
console.log("🌐 ProfilesSearch URL:", url,);


      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      setCandidates(res.data?.data || []);
      const totalPagesCalculated = Math.ceil(
        (res.data?.count || res.data?.meta?.totalCount || 0) / recordsPerPage
      );
      setTotalPages(totalPagesCalculated > 50 ? 50 : totalPagesCalculated);
    }
  } catch (err) {
    console.error("❌ API error:", err);
    setCandidates([]);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (!searchTriggered) return; // prevent empty runs
 
  console.log("🔍 Search triggered! Intelli:", isIntelliSearch);
  handleSearch(1);
}, [searchTriggered, isIntelliSearch]);
 
  

  useEffect(() => {
    if (candidates.length > 0) handleSearch();
  }, [searchParams.sortBy]);


  let Guid="";

  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const guid = localStorage.getItem("guid");
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }

  return (
    <div className="container-fluid mt-4">
      <div className="row">
       
       {/* ✅ Left Filter Column */}
<div className="col-md-3">
  <div className="filter-panel">
    <div className="filter-title d-flex align-items-center">
      <FaFilter size={18} className="me-2 text-primary mb-2" /> Filters
    </div>

    {/* Job Title */}
    <div className="filter-group">
      <div className="d-flex align-items-center mt-2 mb-2">
        <input
          type="checkbox"
          checked={selectedFilters.includes("jobTitle")}
          onChange={() =>
            setSelectedFilters((prev) =>
              prev.includes("jobTitle")
                ? prev.filter((f) => f !== "jobTitle")
                : [...prev, "jobTitle"]
            )
          }
          className="me-2"
        />
        <label className="fw-bold mb-0">Job Titles</label>
      </div>
      <input
        type="text"
        className="form-control"
        placeholder="Enter job title..."
        value={searchParams.jobTitleFilter}
        onChange={(e) => {
          const value = e.target.value;
          setSearchParams((p) => ({ ...p, jobTitleFilter: value }));
          if (value && !selectedFilters.includes("jobTitle")) {
            setSelectedFilters((prev) => [...prev, "jobTitle"]);
          } else if (!value) {
            setSelectedFilters((prev) => prev.filter((f) => f !== "jobTitle"));
          }
        }}
      />
    </div>

    {/* Skills */}
    <div className="filter-group">
      <div className="d-flex align-items-center mt-2 mb-2">
        <input
          type="checkbox"
          checked={selectedFilters.includes("skills")}
          onChange={() =>
            setSelectedFilters((prev) =>
              prev.includes("skills")
                ? prev.filter((f) => f !== "skills")
                : [...prev, "skills"]
            )
          }
          className="me-2"
        />
        <label className="fw-bold mb-0">Skills</label>
      </div>
      <input
        type="text"
        className="form-control"
        placeholder="Enter skills..."
        value={searchParams.skillsFilter}
        onChange={(e) => {
          const value = e.target.value;
          setSearchParams((p) => ({ ...p, skillsFilter: value }));
          if (value && !selectedFilters.includes("skills")) {
            setSelectedFilters((prev) => [...prev, "skills"]);
          } else if (!value) {
            setSelectedFilters((prev) => prev.filter((f) => f !== "skills"));
          }
        }}
      />
    </div>

    {/* Experience */}
    <div className="filter-group">
      <div className="d-flex align-items-center mt-2 mb-2">
        <input
          type="checkbox"
          checked={selectedFilters.includes("experience")}
          onChange={() =>
            setSelectedFilters((prev) =>
              prev.includes("experience")
                ? prev.filter((f) => f !== "experience")
                : [...prev, "experience"]
            )
          }
          className="me-2"
        />
        <label className="fw-bold mb-0">Experience</label>
      </div>
      <input
        type="text"
        className="form-control"
        placeholder="e.g. 5–10 years"
        value={searchParams.experienceFilter}
        onChange={(e) => {
          const value = e.target.value;
          setSearchParams((p) => ({ ...p, experienceFilter: value }));
          if (value && !selectedFilters.includes("experience")) {
            setSelectedFilters((prev) => [...prev, "experience"]);
          } else if (!value) {
            setSelectedFilters((prev) =>
              prev.filter((f) => f !== "experience")
            );
          }
        }}
      />
    </div>

  {/* Company Name */}
<div className="filter-group">
  <div className="d-flex align-items-center mt-2 mb-2">
    <input
      type="checkbox"
      checked={selectedFilters.includes("companyName")}
      onChange={() =>
        setSelectedFilters((prev) =>
          prev.includes("companyName")
            ? prev.filter((f) => f !== "companyName")
            : [...prev, "companyName"]
        )
      }
      className="me-2"
    />
    <label className="fw-bold mb-0">Company Name</label>
  </div>
  <input
    type="text"
    className="form-control"
    placeholder="Enter Company Name"
    value={searchParams.companyNameFilter || ""}
    onChange={(e) => {
      const value = e.target.value;
      setSearchParams((p) => ({ ...p, companyNameFilter: value }));
      if (value && !selectedFilters.includes("companyName")) {
        setSelectedFilters((prev) => [...prev, "companyName"]);
      } else if (!value) {
        setSelectedFilters((prev) =>
          prev.filter((f) => f !== "companyName")
        );
      }
    }}
  />
</div>

    {/* Willing to Switch */}
    <div className="filter-group">
      <div className="d-flex align-items-center mt-2 mb-2">
        <input
          type="checkbox"
          checked={selectedFilters.includes("willingToSwitch")}
          onChange={() =>
            setSelectedFilters((prev) =>
              prev.includes("willingToSwitch")
                ? prev.filter((f) => f !== "willingToSwitch")
                : [...prev, "willingToSwitch"]
            )
          }
          className="me-2"
        />
        <label className="fw-bold mb-0">Willing to Switch</label>
      </div>
      <select
        className="form-control"
        value={searchParams.willingToSwitch}
        onChange={(e) => {
          const value = e.target.value;
          setSearchParams((p) => ({ ...p, willingToSwitch: value }));
          if (value && !selectedFilters.includes("willingToSwitch")) {
            setSelectedFilters((prev) => [...prev, "willingToSwitch"]);
          } else if (!value) {
            setSelectedFilters((prev) =>
              prev.filter((f) => f !== "willingToSwitch")
            );
          }
        }}
      >
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="Unknown">Unknown</option>
      </select>
    </div>

  {/* Employment Type */}
<div className="filter-group">
  <div className="d-flex align-items-center mt-2 mb-2">
    <input
      type="checkbox"
      checked={selectedFilters.includes("employmentType")}
      onChange={() =>
        setSelectedFilters((prev) =>
          prev.includes("employmentType")
            ? prev.filter((f) => f !== "employmentType")
            : [...prev, "employmentType"]
        )
      }
      className="me-2"
    />
    <label className="fw-bold mb-0">Employment Type</label>
  </div>

  <Select
    isMulti
    options={employmentTypeOptions}
    value={employmentTypeOptions.filter((opt) =>
      searchParams.employmentType?.split(",").includes(opt.value)
    )}
    onChange={(selectedOptions) => {
      const values = selectedOptions.map((opt) => opt.value).join(",");
      setSearchParams((p) => ({ ...p, employmentType: values }));

      if (values && !selectedFilters.includes("employmentType")) {
        setSelectedFilters((prev) => [...prev, "employmentType"]);
      } else if (!values) {
        setSelectedFilters((prev) =>
          prev.filter((f) => f !== "employmentType")
        );
      }
    }}
    className="basic-multi-select"
    classNamePrefix="select"
    placeholder="Select Employment Types..."
    styles={{
              control: (provided) => ({
                ...provided,
                height: 70,
                borderRadius: 10,
                fontSize: "12px",
              }),
              placeholder: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
            }}
  />
</div>

{/* Work Permit */}
<div className="filter-group">
  <div className="d-flex align-items-center mt-2 mb-2">
    <input
      type="checkbox"
      checked={selectedFilters.includes("workPermit")}
      onChange={() =>
        setSelectedFilters((prev) =>
          prev.includes("workPermit")
            ? prev.filter((f) => f !== "workPermit")
            : [...prev, "workPermit"]
        )
      }
      className="me-2"
    />
    <label className="fw-bold mb-0">Work Permit</label>
  </div>

  <Select
    isMulti
    options={workPermitOptions}
    value={workPermitOptions.filter((opt) =>
      searchParams.workPermit?.split(",").includes(opt.value)
    )}
    onChange={(selectedOptions) => {
      const values = selectedOptions.map((opt) => opt.value).join(",");
      setSearchParams((p) => ({ ...p, workPermit: values }));

      if (values && !selectedFilters.includes("workPermit")) {
        setSelectedFilters((prev) => [...prev, "workPermit"]);
      } else if (!values) {
        setSelectedFilters((prev) =>
          prev.filter((f) => f !== "workPermit")
        );
      }
    }}
    className="basic-multi-select"
    classNamePrefix="select"
    placeholder="Select Work Permits..."
    styles={{
              control: (provided) => ({
                ...provided,
                height: 70,
                borderRadius: 10,
                fontSize: "12px",
              }),
              placeholder: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
              singleValue: (provided) => ({
                ...provided,
                textAlign: "left",
                fontSize: "12px",
              }),
            }}
  />
</div>

{/* Last Active */}
<div className="filter-group">
  <div className="d-flex align-items-center mt-2 mb-2">
    <input
      type="checkbox"
      checked={selectedFilters.includes("lastActive")}
      onChange={() =>
        setSelectedFilters((prev) =>
          prev.includes("lastActive")
            ? prev.filter((f) => f !== "lastActive")
            : [...prev, "lastActive"]
        )
      }
      className="me-2"
    />
    <label className="fw-bold mb-0">Last Active</label>
  </div>

  <select
    className="form-control"
    value={searchParams.lastActive}
    onChange={(e) => {
      const value = e.target.value;
      setSearchParams((p) => ({ ...p, lastActive: value }));
      if (value && !selectedFilters.includes("lastActive")) {
        setSelectedFilters((prev) => [...prev, "lastActive"]);
      } else if (!value) {
        setSelectedFilters((prev) => prev.filter((f) => f !== "lastActive"));
      }
    }}
  >
    <option value="">Last Active</option>
<option value="7">Last 7 Days</option>
<option value="15">Last 15 Days</option>
<option value="30">Last 30 Days</option>
<option value="60">Last 60 Days</option>
<option value="90">Last 90 Days</option>
<option value="120">Last 120 Days</option>
<option value="150">Last 150 Days</option>
<option value="180">Last 180 Days</option>
<option value="360">Last 360 Days</option>


  </select>
</div>
 <div className="filter-title d-flex align-items-center mt-3">
      <ContactRoundIcon size={20} className="me-2 text-primary" /> Contact Method
    </div>

    {/* Timezone */}
    {!isIntelliSearch && (
<div className="filter-group">
  <div className="d-flex align-items-center mt-2 mb-2">
    <input
      type="checkbox"
      checked={selectedFilters.includes("timezones")}
      onChange={() =>
        setSelectedFilters((prev) =>
          prev.includes("timezones")
            ? prev.filter((f) => f !== "timezones")
            : [...prev, "timezones"]
        )
      }
      className="me-2"
    />
    <label className="fw-bold mb-0">Timezone</label>
  </div>

  <Select
    isMulti
    options={timezoneOptions}
    value={timezoneOptions.filter((opt) =>
      searchParams.timezones
        ?.map((t) => t.timezone)
        .includes(opt.value)
    )}
    onChange={(selectedOptions) => {
      const formatted = selectedOptions.map((opt) => ({
        excluded: false,
        timezone: opt.value
      }));

      setSearchParams((p) => ({ ...p, timezones: formatted }));

      if (formatted.length && !selectedFilters.includes("timezones")) {
        setSelectedFilters((prev) => [...prev, "timezones"]);
      } else if (!formatted.length) {
        setSelectedFilters((prev) => prev.filter((f) => f !== "timezones"));
      }
    }}
    className="basic-multi-select"
    classNamePrefix="select"
    placeholder="Select Timezones..."
    styles={{
      control: (provided) => ({
        ...provided,
        height: 70,
        borderRadius: 10,
        fontSize: "12px",
      }),
      placeholder: (provided) => ({
        ...provided,
        textAlign: "left",
        fontSize: "12px",
      }),
      singleValue: (provided) => ({
        ...provided,
        textAlign: "left",
        fontSize: "12px",
      }),
    }}
  />
</div>
)}
{/* ✅ Has Phone Number */}
<div className="filter-group">
  <div className="d-flex align-items-center mt-3">
    <input
      type="checkbox"
      checked={searchParams.hasPhoneNumber === true}
      onChange={(e) => {
        const checked = e.target.checked;
        setSearchParams((p) => ({ ...p, hasPhoneNumber: checked }));
        if (checked && !selectedFilters.includes("hasPhoneNumber")) {
          setSelectedFilters((prev) => [...prev, "hasPhoneNumber"]);
        } else if (!checked) {
          setSelectedFilters((prev) =>
            prev.filter((f) => f !== "hasPhoneNumber")
          );
        }
      }}
      className="me-2"
    />
    <label className="fw-bold mb-0">Phone Number</label>
  </div>
</div>

{/* ✅ Has Email */}
<div className="filter-group">
  <div className="d-flex align-items-center mt-2">
    <input
      type="checkbox"
      checked={searchParams.hasEmail === true}
      onChange={(e) => {
        const checked = e.target.checked;
        setSearchParams((p) => ({ ...p, hasEmail: checked }));
        if (checked && !selectedFilters.includes("hasEmail")) {
          setSelectedFilters((prev) => [...prev, "hasEmail"]);
        } else if (!checked) {
          setSelectedFilters((prev) =>
            prev.filter((f) => f !== "hasEmail")
          );
        }
      }}
      className="me-2"
    />
    <label className="fw-bold mb-0">Email</label>
  </div>
</div>

    <div className="d-grid mt-3">
      <button
        className="btn btn-primary"
        onClick={() => handleSearch(1, isIntelliSearch)}
        disabled={loading}
      >
        {loading ? "Searching..." : "Apply Filters"}
      </button>
    </div>


   <div className="d-grid mt-2">
  <button
    className="btn btn-outline-secondary"
    onClick={() => {
      // ✅ Reset only filter-related fields (not keyword/location/relocate)
      setSearchParams((prev) => ({
        ...prev,
        jobTitleFilter: "",
        skillsFilter: "",
        experienceFilter: "",
        willingToSwitch: "",
        employmentType: "",
        workPermit: "",
        sortBy: prev.sortBy || "relevancy", // preserve sort order if needed
        lastActive: "",
         hasPhoneNumber: true, // ✅ default to true again
            hasEmail: true, // ✅ default to true again
           companyNameFilter: "", 
           timezones: [],

      }));
 setSelectedFilters(["hasPhoneNumber", "hasEmail"]); // ✅ keep them active by default
      // ✅ Uncheck all checkboxes
      setSelectedFilters([]);
    }}
  >
    Reset Filters
  </button>
</div>


  </div>
</div>


        {/* ✅ Right Candidates Column */}
        <div className="col-md-9">
          {/* Sort Dropdown */}
          <div className="d-flex space-between mb-3">
             <ReactPaginate
    breakLabel="..."
    nextLabel="Next >"
    onPageChange={(e) => {
      const newPage = e.selected + 1;
      setCurrentPage(newPage);
      handleSearch(newPage); // fetch new page
    }}
    pageRangeDisplayed={2}
    marginPagesDisplayed={2}
    pageCount={totalPages}
    previousLabel="< Prev"
    renderOnZeroPageCount={null}
    forcePage={currentPage - 1}
    containerClassName="pagination"
    pageClassName="page-item"
    pageLinkClassName="page-link"
    previousClassName="page-item"
    nextClassName="page-item"
    previousLinkClassName="page-link"
    nextLinkClassName="page-link"
    activeClassName="active"
  />
            <div className="d-flex align-items-center">
              <label className="me-2 fw-bold">Sort:</label>
              <select
                className="form-select w-auto"
                value={searchParams.sortBy}
                onChange={(e) =>
                  setSearchParams((p) => ({ ...p, sortBy: e.target.value }))
                }
              >
                <option value="relevancy">Relevance</option>
                <option value="activityDate">Last Active — Most Recent</option>
                <option value="dateLastUpdated">
                  Profile Updated — Most Recent
                </option>
                <option value="dateResumeLastUpdated">
                  Resume Updated — Most Recent
                </option>
              </select>
            </div>
               <div className="mt-4 mb-3">
 
</div>
          </div>


          <div className="results-panel">
                    
            {loading ? (
              <p>Loading candidates...</p>
            ) : candidates.length === 0 ? (
              <p>No candidates found.</p>
            ) : (
              <>
         
<div>
              {candidates?.map((c) => (
                 <div
                    key={c.candidateId || c.id}
                onClick={() => {
      setSelectedCandidate(c.candidateId || c.id); // pass entire candidate object
      // setShowModal(true);
    }}
                    style={{ cursor: "pointer" }}
                  >
  <CandidateCard
    key={c.candidateId || c.id}
    candidate={c}
    setSelectedCandidate={setSelectedCandidate}
    setShowModal={setShowModal}
    selectedCandidates={selectedCandidates}      // ✅ pass selected candidates
    setSelectedCandidates={setSelectedCandidates} // ✅ pass setter
   onViewDetails={handleViewDetails}             // ✅ show alert → modal
      onNavigateToDetails={handleNavigateToDetails} // ✅ show alert → navigate
       highlightTerms={[
    keyword,                          // main keyword
    intelliInput,                     // IntelliSearch input
    ...(intelliJobTitles || []),      // Intelli job titles
    ...(intelliLocations || []),      // Intelli locations
    ...(searchParams.jobTitleFilter
      ? searchParams.jobTitleFilter.split(",").map(t => t.trim())
      : []),
    ...(searchParams.skillsFilter
      ? searchParams.skillsFilter.split(",").map(t => t.trim())
      : []),
    ...(searchParams.experienceFilter
      ? searchParams.experienceFilter.split(",").map(t => t.trim())
      : []),
      ...(searchParams.experienceFilter
      ? searchParams.experienceFilter.split(",").map(t => t.trim())
      : []),
  ].filter(Boolean)}   
  />
  </div>
))}
</div>
                      </>
            )}
          </div>
        </div>
      </div>

      <CandidateDetailModal
        show={showModal}
        onClose={() => setShowModal(false)}
        candidateId={selectedCandidate}
      />
      {showScroll && (
  <button
    onClick={scrollToTop}
    style={{
      position: "fixed",
      bottom: "30px",
      right: "30px",
      backgroundColor: "#00a7ac",
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "45px",
      height: "45px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
      cursor: "pointer",
      zIndex: 9999,
      transition: "opacity 0.3s ease-in-out",
    }}
    title="Scroll to top"
  >
    <FaArrowUp size={20} />
  </button>
)}

    </div>
  );
};

export default DiceCandidatesList;
